window.addEventListener("load", function () {
	// Update form when submitted with errors

	// Product title
	let inputs_titles = document.querySelectorAll(".form-row-sku");
	let seenValues = new Set();

	inputs_titles.forEach(function (input) {
		skuTitle(input);
	});

	// Row number
	let i = 1;
	let rowId = document.querySelectorAll(".form-row-id");
	rowId.forEach(function (e) {
		e.innerHTML = i++;
	});

	// Total
	calcTotal();
});

// Get product title
async function skuTitle(el) {
	const targetDiv = el
		.closest("div")
		.parentNode.querySelector(".form-row-title");
	const csrftoken = document.querySelector("[name=csrfmiddlewaretoken]").value;

	if (el.value.length == 13) {
		try {
			const response = await fetch("/order_get_product/", {
				method: "POST",
				body: JSON.stringify({
					sku: el.value,
				}),
				headers: {
					"Content-Type": "application/json",
					"X-CSRFToken": csrftoken,
				},
				mode: "same-origin",
			});

			const data = await response.json();
			targetDiv.textContent = data.result;
			if (data.valid === false) {
				targetDiv.classList.add("warning");
			} else {
				targetDiv.classList.remove("warning");
			}
		} catch (error) {
			targetDiv.textContent = "An expected error occured";
			targetDiv.classList.add("warning");
		}
	} else if (el.value.length >= 1) {
		targetDiv.textContent = "Invalid ISBN";
		targetDiv.classList.add("warning");
	}
}

function calcTotal() {
	const total = document.getElementById("total-order");
	let inputs = document.querySelectorAll("input[type=number]");
	var sum = 0;
	function calculateSum() {
		sum = 0;
		inputs.forEach(function (input) {
			let value = Number(input.value);
			if (!isNaN(value)) {
				sum += value;
			}
		});
		total.innerHTML = sum;
	}
	calculateSum();

	inputs.forEach(function (input) {
		input.addEventListener("keyup", calculateSum);
	});
	total.innerHTML = sum;
}

export default () => ({
	init() {
		this.template = this.$root.querySelector("template");
		this.formsContainer = this.$root.querySelector(".submit-order__forms");
		this.totalFormsInput = this.$root.querySelector(
			`input[name$='-TOTAL_FORMS']`,
		);
	},

	addForm() {
		const newForm = this.template.content.cloneNode(true);

		// replace __prefix__ with the correct index
		const rowId = newForm.querySelector(".form-row-id");
		rowId.innerHTML = this.formsContainer.children.length + 1;
		const errorField = newForm.querySelector(".form-row-id");

		for (let el of newForm.querySelectorAll("input, select, textarea")) {
			if (el.name.includes("__prefix__")) {
				el.name = el.name.replace(
					"__prefix__",
					this.formsContainer.children.length,
				);
			}
			if (el.id.includes("__prefix__")) {
				el.id = el.id.replace(
					"__prefix__",
					this.formsContainer.children.length,
				);
			}
		}
		const labels = newForm.querySelectorAll("label");
		for (let el of labels) {
			if (el.htmlFor.includes("__prefix__")) {
				el.htmlFor = el.htmlFor.replace(
					"__prefix__",
					this.formsContainer.children.length,
				);
			}
		}

		// add the new form to the dom
		this.formsContainer.appendChild(newForm);

		// adjust the management form inputs
		this.totalFormsInput.value = parseInt(this.totalFormsInput.value) + 1;
	},

	deleteForm() {
		// remove the element from the dom
		this.$el.closest(".submit-order__form-row").remove();

		// adjust the ids of the remaining inputs
		for (let i = 0; i < this.formsContainer.children.length; i++) {
			const form = this.formsContainer.children[i];
			const rowId = form.querySelector(".form-row-id");
			rowId.innerHTML = i + 1;
			const inputs = form.querySelectorAll("input, select, textarea");
			for (let el of inputs) {
				el.name = el.name.replace(/\d+/, i);
				el.id = el.id.replace(/\d+/, i);
			}
			const labels = form.querySelectorAll("label");
			for (let el of labels) {
				el.htmlFor = el.htmlFor.replace(/\d+/, i);
			}
		}

		// adjust the management form inputs
		this.totalFormsInput.value = Math.max(
			0,
			parseInt(this.totalFormsInput.value) - 1,
		);

		// refresh total order
		calcTotal();
	},
	async getSkuTitle(e) {
		await skuTitle(e);
	},
	calcTotal() {
		calcTotal();
	},
});
